// autogenerated by channel_search/generate.py -- do not edit
import { flight_phase_t } from "@skydio/lcm/types/common/flight_phase_t";
export { flight_phase_t };

export const FLIGHT_PHASE = {
  channel: "FLIGHT_PHASE",
  channelId: 114,
  type: flight_phase_t
};
